import { useMemo } from 'react';
import { DataTable } from '../components/DataTable';
import { TablePageLayout } from '../components/TablePageLayout';
import { fetchDashboardVendorBills } from '../api/dashboardApi';
import { useQuery } from '@tanstack/react-query';
import { formatDate, formatCurrency } from '../utils/formatters';
import { useScrollRestoration } from '../hooks/useScrollRestoration';

export function VendorBillsPage() {
  const { data, isLoading, isError, error, isFetched } = useQuery({
    queryKey: ['dashboard-vendor-bills'],
    queryFn: fetchDashboardVendorBills,
  });

  const { containerRef, handleScroll } = useScrollRestoration(
    'vendorBillsListScroll',
    isFetched
  );

  const rows = useMemo(() => {
    if (!data || !data.bills) return [];

    return data.bills.map((bill) => {
      const issues = [];
      const ref = bill.ref === 'False' ? '' : (bill.ref || '');
      
      if (!ref) {
        issues.push('Reference is empty');
      }
      if (ref.toLowerCase().includes('waiting')) {
        issues.push('Reference contains "waiting"');
      }

      return [
        <a href={bill.url} target="_blank" rel="noreferrer">{bill.name}</a>,
        ref,
        formatDate(bill.invoice_date),
        bill.responsible_person_name || '-',
        formatCurrency(bill.amount_total),
        issues.join(' ')
      ];
    });
  }, [data]);

  return (
    <TablePageLayout
      title="Vendor bills with issues"
      description="Vendor bills that require attention."
      isLoading={isLoading}
      isError={isError}
      error={error}
      containerRef={containerRef}
      onScroll={handleScroll}
    >
      <DataTable
        headers={['Bill', 'Reference', 'Bill date', 'Responsible', 'Total', 'Issue']}
        rows={rows}
        className="sticky-header"
      />
    </TablePageLayout>
  );
}
